import {
  EXPENSE_ENTRY_ADD_NEW,
  EXPENSE_ENTRY_ADD_NEW_SUCCESS,
  EXPENSE_ENTRY_ADD_NEW_ERROR,
  EXPENSE_ENTRY_DELETE,
  EXPENSE_ENTRY_DELETE_ERROR,
  EXPENSE_ENTRY_DELETE_SUCCESS,
  EXPENSE_ENTRY_EDIT,
  EXPENSE_ENTRY_EDIT_ERROR,
  EXPENSE_ENTRY_EDIT_SUCCESS,
  EXPENSE_ENTRY_GET_BY_ID,
  EXPENSE_ENTRY_GET_BY_ID_ERROR,
  EXPENSE_ENTRY_GET_BY_ID_SUCCESS,
  EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID,
  EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID_ERROR,
  EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID_SUCCESS,
  EXPENSE_ENTRY_RECEIPT_DELETE,
  EXPENSE_ENTRY_RECEIPT_DELETE_SUCCESS,
  EXPENSE_ENTRY_RECEIPT_DELETE_ERROR,
  EXPENSE_ENTRY_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  entries: [],
  mileage: null,
  entry: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
  directionsData: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case EXPENSE_ENTRY_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EXPENSE_ENTRY_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        entry: payload,
      };

    case EXPENSE_ENTRY_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID_SUCCESS:
      return {
        ...state,
        entries: payload,
        loading: false,
      };

    case EXPENSE_ENTRY_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case EXPENSE_ENTRY_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        entry: payload,
        entries: state.entries.concat(payload),
        addSuccess: true,
      };

    case EXPENSE_ENTRY_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EXPENSE_ENTRY_EDIT_SUCCESS:
      return {
        ...state,
        entries: state.entries.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        entry: payload,
        error: null,
        loading: false,
        editSuccess: true,
      };

    case EXPENSE_ENTRY_RECEIPT_DELETE:
      return {
        ...state,
        error: null,
      };
    case EXPENSE_ENTRY_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case EXPENSE_ENTRY_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        entries: state.entries.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case EXPENSE_ENTRY_RECEIPT_DELETE_SUCCESS:
      return {
        ...state,
        deleteSuccess: true,
      };
    case EXPENSE_ENTRY_DELETE_ERROR:
    case EXPENSE_ENTRY_ADD_NEW_ERROR:
    case EXPENSE_ENTRY_EDIT_ERROR:
    case EXPENSE_ENTRY_GET_BY_ID_ERROR:
    case EXPENSE_ENTRY_GET_LIST_BY_EXPENSE_ID_ERROR:
    case EXPENSE_ENTRY_RECEIPT_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
